export const DEFAULT_MAINTENANCE_CONFIG = {
  title: 'Mantenimiento programado',
  message:
    'Estamos actualizando ArbolEc para mejorar el servicio. La plataforma volvera a estar disponible en unos minutos.',
  eta: '',
  contactLabel: '',
  contactHref: '',
}

const getHeaderValue = (headers, name) => {
  if (!headers) return undefined
  if (typeof headers.get === 'function') return headers.get(name)

  const lowerName = name.toLowerCase()
  const headerKey = Object.keys(headers).find(key => key.toLowerCase() === lowerName)
  return headerKey ? headers[headerKey] : undefined
}

export const normalizeMaintenanceConfig = config => {
  if (!config || typeof config !== 'object') return DEFAULT_MAINTENANCE_CONFIG

  const normalized = {
    ...DEFAULT_MAINTENANCE_CONFIG,
    ...Object.entries(config).reduce((acc, [key, value]) => {
      if (typeof value === 'string') acc[key] = value.trim()
      return acc
    }, {}),
  }

  return {
    ...normalized,
    title: normalized.title || DEFAULT_MAINTENANCE_CONFIG.title,
    message: normalized.message || DEFAULT_MAINTENANCE_CONFIG.message,
  }
}

export const loadMaintenanceConfig = async () => {
  try {
    const response = await fetch('/maintenance.json', {
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    })

    if (!response.ok) return DEFAULT_MAINTENANCE_CONFIG

    const data = await response.json()
    return normalizeMaintenanceConfig(data)
  } catch (error) {
    return DEFAULT_MAINTENANCE_CONFIG
  }
}

export const isMaintenancePayload = payload => {
  if (typeof payload === 'string') {
    return payload.toUpperCase().includes('MAINTENANCE')
  }

  if (!payload || typeof payload !== 'object') return false

  const code = String(payload.code || payload.status || payload.error || '').toUpperCase()
  return code === 'MAINTENANCE' || payload.maintenance === true
}

export const isMaintenanceResponse = error => {
  const response = error?.response
  if (!response || response.status !== 503) return false

  const maintenanceHeader = String(
    getHeaderValue(response.headers, 'x-maintenance-mode') || '',
  ).toLowerCase()

  return (
    maintenanceHeader === '1' ||
    maintenanceHeader === 'true' ||
    isMaintenancePayload(response.data)
  )
}
